import { createContext } from 'react';
import type { Context as SharedContext } from '../shared/context';
import type { DataCollectionRuleInterface } from './data_collection_rule';

export type Context = SharedContext & {
  rules: Array<DataCollectionRuleInterface>;
};

const defaultContext = {
  edited: false,
  editing: false,
  editingRuleId: null,
  errors: {},
  loaded: false,
  meta: {
    all_offices_path: '',
    candidate_data_path: '',
    notifications_path: '',
    update_rules_path: '',
    new_rule_path: '',
    pagination: {
      current_page: null,
      next_page: null,
      per_page: null,
      previous_page: null,
      total_entries: null,
      total_pages: null,
    },
  },
  rules: [],
  onAdd: () => {},
  onCancel: () => {},
  // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
  onDelete: (rule) => {},
  // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
  onEdit: (rule) => {},
  // @ts-expect-error - TS7006 - Parameter 'field' implicitly has an 'any' type.
  onFieldChange: (field) => {},
  // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
  onSave: (rule) => {},
} as const;

export const DataCollectionRulesContext =
  // @ts-expect-error - TS2345 - Argument of type '{ readonly edited: false; readonly editing: false; readonly editingRuleId: null; readonly errors: {}; readonly loaded: false; readonly meta: { readonly all_offices_path: ""; readonly candidate_data_path: ""; readonly notifications_path: ""; readonly update_rules_path: ""; readonly new_rule_path: ""; readonly paginat...' is not assignable to parameter of type 'Context'.
  createContext<Context>(defaultContext);
